import { render } from "./TheTagGroup.vue?vue&type=template&id=78f8ed23&scoped=true"
import script from "./TheTagGroup.vue?vue&type=script&lang=js"
export * from "./TheTagGroup.vue?vue&type=script&lang=js"

import "./TheTagGroup.vue?vue&type=style&index=0&id=78f8ed23&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/yh-node-yh-mallrobot-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78f8ed23"]])

export default __exports__